<div mat-dialog-title>{{ TranslationKeys.GeoLocationSelectYourEnvironment | translate }}</div>
<div mat-dialog-content>
  <nimbus-location-list
    [class.is-admin]="isApplicationAdmin"
    [formControl]="control$ | async"
    [locations]="availableLocations$ | async"
    (initialLocation)="setInitialLocation($event)"
  ></nimbus-location-list>
</div>
<div mat-dialog-actions nimbusMaterialButtonsRow>
  <button nimbusSecondaryButton (click)="cancel()">{{ TranslationKeys.GeneralCancel | translate }}</button>
  <button nimbusPrimaryButton class="merge" (click)="apply()">{{ TranslationKeys.GeneralApply | translate }}</button>
</div>
